export enum HoroscopeIconType {
  // Zodiac signs
  aries = 'aries',
  taurus = 'taurus',
  gemini = 'gemini',
  cancer = 'cancer',
  leo = 'leo',
  virgo = 'virgo',
  libra = 'libra',
  scorpio = 'scorpio',
  sagittarius = 'sagittarius',
  capricorn = 'capricorn',
  aquarius = 'aquarius',
  pisces = 'pisces',
}

export const HoroscopeColor = {
  aries: '#7A3234',
  taurus: '#32432C',
  gemini: '#206457',
  cancer: '#956363',
  leo: '#A2553A',
  virgo: '#3C2900',
  libra: '#593952',
  scorpio: '#161631',
  sagittarius: '#90362D',
  capricorn: '#345041',
  aquarius: '#49425D',
  pisces: '#1B728C',
}

export enum HoroscopeIconCategory {
  general = 'general',
  health = 'health',
  love = 'love',
  money = 'money',
} 
